import React, { useState, useEffect } from 'react';
import {
  Box,
  TextField,
  Button,
  Grid,
  Paper,
  Typography,
  MenuItem,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import athleteService from '../services/athleteService';

const EMPTY_FILTERS = {
  athlete_name: '',
  games_name: '',
  games_year: '',
  sport_chinese: '',
};

const SearchForm = ({ onSearch, loading, prefillName }) => {
  const [filters, setFilters] = useState(EMPTY_FILTERS);
  const [options, setOptions] = useState({ sports: [], years: [], games_names: [] });

  // 從統計分析跳轉查詢選手時，同步帶入姓名欄位
  useEffect(() => {
    if (prefillName) {
      setFilters({ ...EMPTY_FILTERS, athlete_name: prefillName });
    }
  }, [prefillName]);

  useEffect(() => {
    let mounted = true;
    athleteService
      .getFilterOptions()
      .then((res) => {
        if (mounted && res.success) setOptions(res.data);
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);

  const handleChange = (field) => (event) => {
    setFilters({ ...filters, [field]: event.target.value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const activeFilters = Object.keys(filters).reduce((acc, key) => {
      const value = String(filters[key]).trim();
      if (value !== '') acc[key] = value;
      return acc;
    }, {});

    if (Object.keys(activeFilters).length === 0) {
      alert('請至少輸入或選擇一個查詢條件');
      return;
    }

    onSearch(activeFilters);
  };

  const handleClear = () => {
    setFilters(EMPTY_FILTERS);
  };

  return (
    <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h5" gutterBottom sx={{ mb: 3 }}>
        運動員查詢
      </Typography>

      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              fullWidth
              label="運動員姓名"
              value={filters.athlete_name}
              onChange={handleChange('athlete_name')}
              placeholder="請輸入姓名"
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              select
              fullWidth
              label="賽事"
              value={filters.games_name}
              onChange={handleChange('games_name')}
            >
              <MenuItem value="">不限</MenuItem>
              {options.games_names.map((name) => (
                <MenuItem key={name} value={name}>
                  {name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={6} sm={6} md={2}>
            <TextField
              select
              fullWidth
              label="年份"
              value={filters.games_year}
              onChange={handleChange('games_year')}
            >
              <MenuItem value="">不限</MenuItem>
              {options.years.map((year) => (
                <MenuItem key={year} value={String(year)}>
                  {year}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={6} sm={6} md={2}>
            <TextField
              select
              fullWidth
              label="運動類別"
              value={filters.sport_chinese}
              onChange={handleChange('sport_chinese')}
            >
              <MenuItem value="">不限</MenuItem>
              {options.sports.map((sport) => (
                <MenuItem key={sport} value={sport}>
                  {sport}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={12} md={2}>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button
                type="submit"
                variant="contained"
                startIcon={<SearchIcon />}
                disabled={loading}
                fullWidth
              >
                {loading ? '查詢中' : '查詢'}
              </Button>
              <Button
                variant="outlined"
                startIcon={<ClearIcon />}
                onClick={handleClear}
                disabled={loading}
              >
                清除
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Paper>
  );
};

export default SearchForm;
